<p-password
  [inputStyleClass]="password && !form.valid ? 'has-error' : ''"
  [ngModel]="password"
  (ngModelChange)="changePassword($event)"
>
  <ng-template #header>
    <h6>Pick a password</h6>
  </ng-template>
  <ng-template #footer>
    <p-divider></p-divider>
    <p class="mt-2">Requirements</p>
    <ul class="pl-2 m-l-10 mt-0" style="line-height: 1.5">
      <li>At least one lowercase</li>
      <li>At least one uppercase</li>
      <li>At least one numeric</li>
      <li>Minimum 8 characters</li>
    </ul>
  </ng-template>
</p-password>
